import { render, staticRenderFns } from "./RouterHealthCheck.vue?vue&type=template&id=7beaffdd&"
import script from "./RouterHealthCheck.vue?vue&type=script&lang=js&"
export * from "./RouterHealthCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports